import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchChargesApi } from '../../api/charges-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  charges: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchChargesListing = createAsyncThunk(
  'charges/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
    try {
      const paramsObj = {
        ...updatedParamsObject,
      };
      const res = await fetchChargesApi(paramsObj, '');
      if (res?.status) {
        dispatch(setQuickLinks(res?.user_filters));
      }
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

const ChargesSlice = createSlice({
  name: 'charges',
  initialState,
  reducers: {
    setChargesLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setChargesActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchChargesListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchChargesListing.fulfilled, (state, action) => {
        if (state.loading) {
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.charges = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchChargesListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setChargesLoading, setChargesActiveColumn } = ChargesSlice.actions;
export default ChargesSlice.reducer;
